import { useConfigurator } from '@/app/store/configurator/hooks/use-configurator';
import {
	SECTIONS_LEVEL_COUNTS,
	SHELF_DECK,
	SHELVE_MATERIALS_LIMITS,
} from '@/shared/constants/configurator';
import { useConfiguratorData } from '@/widgets/configurator';
import { useTranslation } from 'react-i18next';

export const useConfiguratorOptions = () => {
	const { state } = useConfigurator();
	const { t } = useTranslation();
	const { data } = useConfiguratorData();

	const heightOptions = (data?.heights?.[state.material] || []).map((height) => ({
		label: `${height} ${t('units.mm')}`,
		value: height,
	}));
	const widthOptions = (data?.widths || []).map((width) => ({
		label: `${width} ${t('units.mm')}`,
		value: width,
	}));
	const depthOptions = (data?.depths || []).map((depth) => ({
		label: `${depth} ${t('units.mm')}`,
		value: depth,
	}));
	const levelsOptions = SECTIONS_LEVEL_COUNTS.map((level) => ({
		label: level.toString(),
		value: level,
	}));
	const displayShelfDeckOptions = SHELF_DECK.filter((option) =>
		SHELVE_MATERIALS_LIMITS[state.material].includes(option.value),
	).map((option) => ({
		...option,
		label: t(option.label),
	}));

	return {
		heightOptions,
		widthOptions,
		depthOptions,
		levelsOptions,
		displayShelfDeckOptions,
	};
};
